import apiClient from "@/axios";

export const getDeveloper = async (url) => {
  const response = await apiClient.post("/user/developer/process-developer-link", {
    url: url,
  });
  return response;
};

export const processDeveloperByStoreId = async (storeId, country) => {
  const response = await apiClient.post("/user/developer/process-developer-store-id", {
    storeId: storeId,
    country: country,
  })
  return response;
}


export const getDeveloperById = async (developerId) => {
  const response = await apiClient.post(
    "/user/developer/get-developer",
    {
      developerId: developerId,
    }
  );
  return response.data;
};

export const getDeveloperWithApps = async (developerId) => {
  const response = apiClient.post("/user/developer/get-developer-with-apps", {
    developerId: developerId,
  });
  return response;
};

export const getDeveloperFromLibrary = async (developerId) => {
  const response = await apiClient.post("/user/library/developer/get-developer", {
    developerId: developerId
  });
  return response;
}

export const getDeveloperByStoreId = async (storeId) => {
  const response = await apiClient.post("/user/developer/get-developer-by-store-id", {
    storeId: storeId
  });
  return response;
}